import { render, staticRenderFns } from "./new-modal.vue?vue&type=template&id=247a0590&"
import script from "./new-modal.vue?vue&type=script&lang=js&"
export * from "./new-modal.vue?vue&type=script&lang=js&"
import style0 from "./new-modal.vue?vue&type=style&index=0&id=247a0590&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports